export enum NotificationSearchBooleanOptions {
  All = "0",
  IsSet = "1",
  NotSet = "2"
}
